export default "__VITE_ASSET__SRd1CvwA__"